// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BranchSelectionModal_branch-selection-modal__Git52 {
  width: 116rem;
  max-width: 100%;
  text-align: center;
}

.BranchSelectionModal_branch-selection-modal__select-branch-text__FZ4US {
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/BranchSelectionModal/BranchSelectionModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".branch-selection-modal {\n  width: 116rem;\n  max-width: 100%;\n  text-align: center;\n}\n\n.branch-selection-modal__select-branch-text {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branch-selection-modal": `BranchSelectionModal_branch-selection-modal__Git52`,
	"branch-selection-modal__select-branch-text": `BranchSelectionModal_branch-selection-modal__select-branch-text__FZ4US`
};
export default ___CSS_LOADER_EXPORT___;
